<template>
    <div>
        <div v-if="!apiKey">No API key available.</div>
        <div v-if="apiKey">
            <v-row>
                <v-col cols="4" class="py-0">
                    <v-select v-model="token"
                            :items="sections"
                            item-text="text"
                            item-value="token"
                            label="Course type">
                    </v-select>
                </v-col>
                <v-col cols="4" class="py-0">
                    <v-select v-model="flavor"
                            :items="flavors"
                            label="Flavor">
                    </v-select>
                </v-col>
            </v-row>

            <iframe :src="html" v-if="html"></iframe>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    iframe {
        display: block;
        border: none;
        min-height: 600px;
        width: 100%;
    }
</style>
<script>
import store from "@/services/store";
import { iframe } from "@/services/widgets";

export default {
    props: ["id"],
    data: () => ({
        sections: [
            { token: "vku-zurich",    id: "vku-zurich", lang: "de", text: "VKU: Zürich"},
            { token: "vku-zurich-en", id: "vku-zurich", lang: "en", text: "VKU: Zürich (English)"},
            { token: "vku-lachen",    id: "vku-lachen", lang: "de", text: "VKU: Lachen SZ"},
            { token: "pgs-zurich",    id: "pgs-zurich", lang: "de", text: "PGS: Zürich"},
            { token: "pgs-zurich-en", id: "pgs-zurich", lang: "en", text: "PGS: Zürich (English)"},
            { token: "pgs-lachen",    id: "pgs-lachen", lang: "de", text: "PGS: Lachen SZ"},
        ],
        token: "vku-zurich",
        flavors: [
            { value: "sari", text: "SARI" },
            { value: "pollice", text: "Pollice" },
        ],
        flavor: "sari",
        html: null,
        apiKey: null
    }),
    mounted() {
        this.updateHtml();
    },
    methods: {
        updateHtml() {
            this.apiKey = store.state.id.apiKey;

            const section = this.sections.find(s => s.token === this.token);
            const props = {
                "api-key": this.apiKey,
                "product-id": this.id,
                "section-id": section.id,
                "language-id": section.lang,
                "redirect-url": "https://www.drivingteam.ch/thank-you-page",
                "flavor": this.flavor
            };
            this.html = iframe("sari", props, 600);
        }
    },
    watch: {
        flavor() {
            this.updateHtml();
        },
        token() {
            this.updateHtml();
        }
    }
}
</script>